module.exports = __webpack_public_path__ + "media/images/e-bilet/Kyiv__mobile__bg_new-b82e9e057bd4ebea186fec72cf325003.jpg";